import { Document } from '@anews/types'

import { anyFieldChanged } from './helpers'

export function documentChanged(a?: Document, b?: Document) {
  return anyFieldChanged(['slug', 'date', 'programId', 'programsIds', 'typeId'], a, b)
}
